// extracted by mini-css-extract-plugin
module.exports = {"account":"styles_account__2FZRH","logout":"styles_logout__3kBkP","name":"styles_name__2t4fL"};